import React, { useState } from "react";
import BodyHeader from "../BodyHeader";
import PlusIcon from "assets/icons/Plus.svg";
import SearchBar from "../SearchBarActivities";
import GenericTable from "../GenericTable";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ViewIcon from "assets/icons/View.svg";
import DownloadIcon from "assets/icons/Download.svg";
import PayNowIcon from "assets/icons/PayNow.svg";
import { renderCell } from "../../../utils/utils";
import GenericModal from "../../../Ui/Modal";
import InfoModal from "../Details";
import ButtonComponent from "../../../Ui/Button";
import Repair1 from "assets/images/Repair1.png";
import Repair2 from "assets/images/Repair2.png";
import Section from "../Details";
import Divider from "@mui/material/Divider";
const TableScreen = ({
  title = "",
  description = "",
  placeholder = "",
  headers = [],
  rows = [],
  onSearch,
  search = true,
  renderCell,
  // Pagination props
  currentPage = 1,
  setCurrentPage,
  resultsPerPage = 10,
  onResultsPerPageChange,
  totalCount = 0,
  useExternalPagination = false,
}) => {
  return (
    <div className=" flex flex-col  ">
      <div className="flex flex-col md:gap-8 gap-4 md:py-8 py-4">
        <BodyHeader title={title} description={description}></BodyHeader>
        {search && (
          <SearchBar
            label="Search invoice"
            placeholder={placeholder}
            select={[
              // { label: "Status", values: ["A", "B", "C"] },footer[modalState
              { label: "Sort By", values: ["A", "B", "C"] },
              { label: "Date Range", values: ["A", "B", "C"] },
            ]}
            onSearch={onSearch}
          ></SearchBar>
        )}
      </div>

      <div className="mt-4 bg-[#F3F3F3] mb-8">
        <GenericTable
          resultsPerPage={resultsPerPage}
          headers={headers}
          rows={rows}
          renderCell={renderCell}
          pagination={null}
          padding={true}
          // Pass pagination props if using external pagination
          currentPage={useExternalPagination ? currentPage : undefined}
          setCurrentPage={useExternalPagination ? setCurrentPage : undefined}
          onResultsPerPageChange={
            useExternalPagination ? onResultsPerPageChange : undefined
          }
          totalCount={useExternalPagination ? totalCount : undefined}
          useExternalPagination={useExternalPagination}
        />
      </div>
    </div>
  );
};

export default TableScreen;
